// actions/crm/get-leads3.ts
export const searchLeads = async (firstName: string, lastName: string) => {
    try {
      const response = await fetch(`/api/crm/leads/search?firstName=${firstName}&lastName=${lastName}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error searching leads:", error);
      throw error;
    }
  };